<template>
  <v-expansion-panels v-model="attrsPanel">
    <v-expansion-panel>
      <v-expansion-panel-header class="text-h6 font-weight-regular">
        <v-row>
          <v-col md="auto">
            {{ $t('FORM_BUILDER.FROM_BUILDER_TITLE') }}
          </v-col>
          <v-spacer />
          <v-col md="auto">
            <v-btn
              v-if="isShow && form.length"
              class="mx-5"
              color="primary"
              @click.stop="edit"
              >{{ $t('BUTTON.EDIT') }}</v-btn
            >
            <v-btn
              v-else-if="isShow && !form.length"
              class="mx-5"
              color="primary"
              @click.stop="create"
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t('BUTTON.ADD_FIELDS') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <create-form-page
          v-model="form"
          :errors="errors.getAll()"
          :disabled="isShow"
        >
          <template v-if="!isShow" v-slot:buttons>
            <v-btn
              outlined
              class="mr-5"
              depressed
              color="grey"
              large
              @click.prevent="cancel"
            >
              {{ $t('BUTTON.CANCEL') }}
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="isEdit"
              depressed
              large
              color="success"
              class="mr-5"
              @click.prevent="updateServiceAttributes"
            >
              {{ $t('BUTTON.UPDATE') }}
            </v-btn>
            <v-btn
              v-else-if="isCreate"
              depressed
              large
              color="success"
              class="mr-5"
              @click.prevent="updateServiceAttributes"
            >
              {{ $t('BUTTON.CREATE') }}
            </v-btn>
          </template>
        </create-form-page>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import CreateFormPage from '@/modules/form_builder/pages/CreateFormPage';
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import { CREATE, EDIT, SHOW } from '@/modules/_global/mixins/form-editable';

export default {
  name: 'Attributes',

  components: {
    CreateFormPage
  },

  mixins: [errors],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    form: [],
    mode: SHOW,
    attrsPanel: null
  }),

  computed: {
    isEdit() {
      return this.mode === EDIT;
    },
    isCreate() {
      return this.mode === CREATE;
    },
    isShow() {
      return this.mode === SHOW;
    }
  },

  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (v.length) {
          this.openPanel();
        }
      }
    }
  },

  created() {
    this.getServiceAttributes();
  },

  methods: {
    ...mapActions('service', ['getAttributes', 'updateAttributes']),

    getServiceAttributes() {
      this.getAttributes(this.id)
        .then(response => {
          this.form = response.data.data;
          if (this.form.length) {
            this.mode = SHOW;
          }
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    updateServiceAttributes() {
      this.updateAttributes({ id: this.id, data: this.form })
        .then(() => {
          this.mode = SHOW;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    openPanel() {
      if (!this.attrsPanel) {
        this.attrsPanel = 0;
      }
    },
    edit() {
      this.openPanel();
      this.mode = EDIT;
    },
    create() {
      this.openPanel();
      this.mode = CREATE;
    },
    cancel() {
      this.mode = SHOW;
      this.getServiceAttributes();
    }
  }
};
</script>

<style scoped></style>
